import { useAppSelector, useAppDispatch } from '~/store/hooks'

import { CONTROLS_PANEL } from 'store/panel/types'

import Panel, { PanelSection } from 'components/UIKit/Panel'
import { MathUtils } from 'three'
import { set3DRotation } from '~/store/camera'
import { Slider } from '~/ui/Slider'

export default function Camera3DControlsPanel({ alignment = 'right' }: { alignment?: string }) {
  const dispatch = useAppDispatch()
  const three = useAppSelector(state => state.camera.three)
  const { azimuth, polar } = three.rotation
  const normalAzimuth = MathUtils.euclideanModulo(azimuth, Math.PI * 2)
  return (
    <Panel
      alignment={alignment}
      canMinimize
      landscape
      panelKey={CONTROLS_PANEL}
      stretchContainer
      title="3D Controls"
      width="330px"
    >
      <PanelSection>
        <div className="flex flex-col gap-4">
          <div>
            <Slider
              label="Vertical"
              minValue={0}
              maxValue={0.5 * Math.PI}
              step={(0.5 * Math.PI) / 50}
              value={polar}
              hideOutput
              onChange={value => dispatch(set3DRotation({ polar: value, azimuth, passive: false }))}
            />
            <div className="flex flex-row justify-between">
              <span>Top</span>
              <span>Ground</span>
            </div>
          </div>
          <div>
            <Slider
              label="Horizontal"
              minValue={0}
              maxValue={2 * Math.PI}
              step={(Math.PI * 2) / 50}
              value={normalAzimuth}
              hideOutput
              onChange={value => {
                dispatch(set3DRotation({ polar, azimuth: value, passive: false }))
              }}
            />
            <div className="flex flex-row justify-between">
              <span>Front</span>
              <span>Left</span>
              <span>Back</span>
              <span>Right</span>
              <span>Front</span>
            </div>
          </div>
        </div>
      </PanelSection>
    </Panel>
  )
}
